import { Avatar, Box, Button, ButtonGroup, IconButton as IconButtonMui, Menu, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import tinycolor from 'tinycolor2';
import Icon from '../components/ui/Icon';
import IconButton from '../components/ui/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useContextMenu } from '../hooks/useContextMenu';
import { useOnlineStatus } from '../hooks/useOnlineStatus';
import { useTheme } from '../hooks/useTheme';
import { capitalizeFirstLetter, formatName } from '../utils/capitalize';

const ProfileMenu = () => {
    const { anchorPosition, isOpen, handleOpen, handleClose } = useContextMenu(false);
    const { isOnline } = useOnlineStatus();
    const { user, logout } = useAuth();
    const { t } = useTranslation();
    const { muiTheme } = useTheme();
    const navigate = useNavigate();

    const handleLogout = async () => {
        logout();
        navigate('/login');
    };

    return (
        <>
            <IconButtonMui onClick={handleOpen} size="small">
                <Avatar
                    alt="Profile"
                    sx={{
                        width: 30,
                        height: 30,
                        bgcolor: user?.color,
                        color: tinycolor(user?.color).isDark() ? muiTheme.palette.common.white : muiTheme.palette.common.black,
                    }}
                >
                    {!isOnline && <Icon name="wifiOff" color="disabled" />}
                </Avatar>
            </IconButtonMui>

            <Menu open={isOpen} onClose={handleClose} anchorReference="anchorPosition" anchorPosition={anchorPosition || undefined}>
                <Box sx={{ gap: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2 }}>
                    <Box
                        sx={{
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '100%',
                            minHeight: 48,
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{
                                textAlign: 'center',
                                flexGrow: 1,
                            }}
                        >
                            @{user?.username}
                        </Typography>

                        <IconButton
                            iconName="close"
                            onClick={handleClose}
                            size="small"
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: '50%',
                                transform: 'translateY(-50%)',
                            }}
                        />
                    </Box>

                    <Avatar
                        alt="Profile"
                        sx={{
                            width: 80,
                            height: 80,
                            bgcolor: user?.color,
                            color: tinycolor(user?.color).isDark() ? muiTheme.palette.common.white : muiTheme.palette.common.black,
                        }}
                    >
                        {!isOnline && <Icon name="wifiOff" color="disabled" />}
                    </Avatar>

                    <Typography variant="h6" fontWeight="bold" textAlign="center">
                        {capitalizeFirstLetter(t('hello'))} {formatName(user?.firstName, user?.lastName)} !
                    </Typography>

                    <ButtonGroup variant="contained" color="inherit" size="large">
                        <Button
                            startIcon={<Icon name="person" />}
                            onClick={() => {
                                navigate('/profile');
                                handleClose();
                            }}
                        >
                            {capitalizeFirstLetter(t('myProfile'))}
                        </Button>
                        <Button
                            startIcon={<Icon name="logout" />}
                            onClick={() => {
                                handleLogout();
                                handleClose();
                            }}
                        >
                            {capitalizeFirstLetter(t('logout'))}
                        </Button>
                    </ButtonGroup>
                </Box>
            </Menu>
        </>
    );
};

export default ProfileMenu;
